import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/mileage-rates/new/loading';

export const Route = createFileRoute('/_private/settings/mileage-rates/new')({
  pendingComponent: Loading,
});
